/* tslint:disable */
/* eslint-disable */
/* @relayHash 975b7cb1d8dc351af8d27c3f4d395f39 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Page = {
    offset?: number | null;
    limit?: number | null;
};
export type SocialEventFilter = {
    name?: string | null;
    title?: string | null;
    afterDate?: string | null;
    beforeDate?: string | null;
    createdAfter?: string | null;
};
export type OrderBy = {
    ascending?: boolean | null;
    field: string;
};
export type App_Dashboard_QueryVariables = {
    page?: Page | null;
    filter?: SocialEventFilter | null;
    orderBy?: OrderBy | null;
};
export type App_Dashboard_QueryResponse = {
    readonly socialEvents: {
        readonly " $fragmentRefs": FragmentRefs<"Dashboard_socialEvents">;
    } | null;
    readonly candidate: {
        readonly " $fragmentRefs": FragmentRefs<"Dashboard_candidate">;
    } | null;
};
export type App_Dashboard_Query = {
    readonly response: App_Dashboard_QueryResponse;
    readonly variables: App_Dashboard_QueryVariables;
};



/*
query App_Dashboard_Query(
  $page: Page
  $filter: SocialEventFilter
  $orderBy: OrderBy
) {
  socialEvents(page: $page, filter: $filter, orderBy: $orderBy) {
    ...Dashboard_socialEvents
  }
  candidate {
    ...Dashboard_candidate
    id
  }
}

fragment CourseCard_course on Course {
  ident: id
  name
  bannerImageURL
  externalLink
  excerpt
  category {
    color
    name
  }
}

fragment Dashboard_candidate on Candidate {
  firstName
  skillGroupType
  skillGroupTypeConfirmed
  chatHistory
  candidateType
  areaProgress {
    practiceArea {
      id
    }
    practiceSkillsDone {
      id
    }
    practiceSkillsRemaining {
      id
    }
  }
  ...PlacementGraph_candidate
  myCourses {
    progress {
      completed
    }
    status
    course {
      __typename
      ...CourseCard_course
    }
  }
  ...Pathway_candidate
  ...Roadmap_candidate
  ...RobertChat_candidate
}

fragment Dashboard_socialEvents on SocialEventPage {
  edges {
    id
    name
    startDate
  }
  pageInfo {
    total
    offset
    limit
    given
  }
}

fragment Pathway_candidate on Candidate {
  qualificationsForDegree: qualifications(qualificationType: degree) {
    id
  }
  qualificationsForSQE1: qualifications(qualificationType: sqe1) {
    id
  }
  qualificationsForSQE2: qualifications(qualificationType: sqe2) {
    id
  }
  characterSuitabilityCompleted
  placements {
    edges {
      id
      approved
    }
  }
}

fragment PlacementGraph_candidate on Candidate {
  id
  placements {
    edges {
      id
      name
      startDate
      endDate
      approved
    }
  }
}

fragment Roadmap_candidate on Candidate {
  qualificationsForDegree: qualifications(qualificationType: degree) {
    id
  }
  qualificationsForSQE1: qualifications(qualificationType: sqe1) {
    id
  }
  qualificationsForSQE2: qualifications(qualificationType: sqe2) {
    id
  }
  qualificationsForGDL: qualifications(qualificationType: gdl) {
    id
  }
  qualificationsForLPC: qualifications(qualificationType: lpc) {
    id
  }
  characterSuitabilityCompleted
  skillGroupType
  skillGroupTypeConfirmed
  hiddenQualifications
  roadmapItems
  roadmapCompleted
  placements {
    edges {
      id
      name
      startDate
      endDate
      approved
      partTimeDays
      fullTime
      daysMissed
    }
  }
  areaProgress {
    practiceArea {
      id
      name
      practiceSkills {
        edges {
          id
          name
          practiceSkillGroups {
            edges {
              id
              name
              practiceSubSkills {
                edges {
                  id
                  name
                  practiceSubSkillType
                  minSuggestedEntryCount
                  doneEntryCount
                  order
                }
              }
            }
          }
        }
      }
    }
  }
}

fragment RobertChat_candidate on Candidate {
  firstName
  skillGroupType
  skillGroupTypeConfirmed
  hiddenQualifications
  chatHistory
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Page",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filter",
            "type": "SocialEventFilter",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "orderBy",
            "type": "OrderBy",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        } as any),
        ({
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "orderBy"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "startDate",
        "args": null,
        "storageKey": null
    } as any), v5 = [
        (v2 /*: any*/)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_Dashboard_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "socialEvents",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SocialEventPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Dashboard_socialEvents",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "candidate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Candidate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "Dashboard_candidate",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_Dashboard_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "socialEvents",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SocialEventPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "SocialEvent",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "pageInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "total",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "offset",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "limit",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "given",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "candidate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Candidate",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "firstName",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "skillGroupType",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "skillGroupTypeConfirmed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "chatHistory",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "candidateType",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "areaProgress",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PracticeAreaProgress",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "practiceArea",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PracticeArea",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "practiceSkills",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PracticeSkillPage",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PracticeSkill",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "practiceSkillGroups",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PracticeSkillGroupPage",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "PracticeSkillGroup",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v3 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "practiceSubSkills",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "PracticeSubSkillPage",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "edges",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PracticeSubSkill",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v2 /*: any*/),
                                                                                        (v3 /*: any*/),
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "practiceSubSkillType",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "minSuggestedEntryCount",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "doneEntryCount",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "alias": null,
                                                                                            "name": "order",
                                                                                            "args": null,
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "practiceSkillsDone",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PracticeSkill",
                                    "plural": true,
                                    "selections": (v5 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "practiceSkillsRemaining",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PracticeSkill",
                                    "plural": true,
                                    "selections": (v5 /*: any*/)
                                }
                            ]
                        },
                        (v2 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "placements",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "PlacementPage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Placement",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        (v4 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "endDate",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "approved",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "partTimeDays",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "fullTime",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "daysMissed",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "myCourses",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "MyCourse",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "progress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Progress",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "completed",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "status",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "course",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "__typename",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": "ident",
                                            "name": "id",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "bannerImageURL",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "externalLink",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "excerpt",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "category",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Category",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "color",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "qualificationsForDegree",
                            "name": "qualifications",
                            "storageKey": "qualifications(qualificationType:\"degree\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "qualificationType",
                                    "value": "degree"
                                }
                            ],
                            "concreteType": "Qualification",
                            "plural": true,
                            "selections": (v5 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "qualificationsForSQE1",
                            "name": "qualifications",
                            "storageKey": "qualifications(qualificationType:\"sqe1\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "qualificationType",
                                    "value": "sqe1"
                                }
                            ],
                            "concreteType": "Qualification",
                            "plural": true,
                            "selections": (v5 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "qualificationsForSQE2",
                            "name": "qualifications",
                            "storageKey": "qualifications(qualificationType:\"sqe2\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "qualificationType",
                                    "value": "sqe2"
                                }
                            ],
                            "concreteType": "Qualification",
                            "plural": true,
                            "selections": (v5 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "characterSuitabilityCompleted",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "qualificationsForGDL",
                            "name": "qualifications",
                            "storageKey": "qualifications(qualificationType:\"gdl\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "qualificationType",
                                    "value": "gdl"
                                }
                            ],
                            "concreteType": "Qualification",
                            "plural": true,
                            "selections": (v5 /*: any*/)
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "qualificationsForLPC",
                            "name": "qualifications",
                            "storageKey": "qualifications(qualificationType:\"lpc\")",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "qualificationType",
                                    "value": "lpc"
                                }
                            ],
                            "concreteType": "Qualification",
                            "plural": true,
                            "selections": (v5 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hiddenQualifications",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "roadmapItems",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "roadmapCompleted",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_Dashboard_Query",
            "id": null,
            "text": "query App_Dashboard_Query(\n  $page: Page\n  $filter: SocialEventFilter\n  $orderBy: OrderBy\n) {\n  socialEvents(page: $page, filter: $filter, orderBy: $orderBy) {\n    ...Dashboard_socialEvents\n  }\n  candidate {\n    ...Dashboard_candidate\n    id\n  }\n}\n\nfragment CourseCard_course on Course {\n  ident: id\n  name\n  bannerImageURL\n  externalLink\n  excerpt\n  category {\n    color\n    name\n  }\n}\n\nfragment Dashboard_candidate on Candidate {\n  firstName\n  skillGroupType\n  skillGroupTypeConfirmed\n  chatHistory\n  candidateType\n  areaProgress {\n    practiceArea {\n      id\n    }\n    practiceSkillsDone {\n      id\n    }\n    practiceSkillsRemaining {\n      id\n    }\n  }\n  ...PlacementGraph_candidate\n  myCourses {\n    progress {\n      completed\n    }\n    status\n    course {\n      __typename\n      ...CourseCard_course\n    }\n  }\n  ...Pathway_candidate\n  ...Roadmap_candidate\n  ...RobertChat_candidate\n}\n\nfragment Dashboard_socialEvents on SocialEventPage {\n  edges {\n    id\n    name\n    startDate\n  }\n  pageInfo {\n    total\n    offset\n    limit\n    given\n  }\n}\n\nfragment Pathway_candidate on Candidate {\n  qualificationsForDegree: qualifications(qualificationType: degree) {\n    id\n  }\n  qualificationsForSQE1: qualifications(qualificationType: sqe1) {\n    id\n  }\n  qualificationsForSQE2: qualifications(qualificationType: sqe2) {\n    id\n  }\n  characterSuitabilityCompleted\n  placements {\n    edges {\n      id\n      approved\n    }\n  }\n}\n\nfragment PlacementGraph_candidate on Candidate {\n  id\n  placements {\n    edges {\n      id\n      name\n      startDate\n      endDate\n      approved\n    }\n  }\n}\n\nfragment Roadmap_candidate on Candidate {\n  qualificationsForDegree: qualifications(qualificationType: degree) {\n    id\n  }\n  qualificationsForSQE1: qualifications(qualificationType: sqe1) {\n    id\n  }\n  qualificationsForSQE2: qualifications(qualificationType: sqe2) {\n    id\n  }\n  qualificationsForGDL: qualifications(qualificationType: gdl) {\n    id\n  }\n  qualificationsForLPC: qualifications(qualificationType: lpc) {\n    id\n  }\n  characterSuitabilityCompleted\n  skillGroupType\n  skillGroupTypeConfirmed\n  hiddenQualifications\n  roadmapItems\n  roadmapCompleted\n  placements {\n    edges {\n      id\n      name\n      startDate\n      endDate\n      approved\n      partTimeDays\n      fullTime\n      daysMissed\n    }\n  }\n  areaProgress {\n    practiceArea {\n      id\n      name\n      practiceSkills {\n        edges {\n          id\n          name\n          practiceSkillGroups {\n            edges {\n              id\n              name\n              practiceSubSkills {\n                edges {\n                  id\n                  name\n                  practiceSubSkillType\n                  minSuggestedEntryCount\n                  doneEntryCount\n                  order\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RobertChat_candidate on Candidate {\n  firstName\n  skillGroupType\n  skillGroupTypeConfirmed\n  hiddenQualifications\n  chatHistory\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '0105f64a19a70676a138621e7d9e01c9';
export default node;
